import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["as", "margin", "isUnstyled", "elementRef", "styles"];
var _dec, _dec2, _class, _List;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Children, Component } from 'react';
import { View } from '@instructure/ui-view';
import { passthroughProps, safeCloneElement } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
import { ListItem } from './ListItem';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
let List = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_List = class List extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  renderChildren() {
    return Children.map(this.props.children, child => {
      if (!child) return; // ignore null, falsy children

      return safeCloneElement(child, {
        isUnstyled: this.props.isUnstyled,
        delimiter: this.props.delimiter,
        size: this.props.size,
        spacing: this.props.itemSpacing
      });
    });
  }
  render() {
    const _this$props3 = this.props,
      as = _this$props3.as,
      margin = _this$props3.margin,
      isUnstyled = _this$props3.isUnstyled,
      elementRef = _this$props3.elementRef,
      styles = _this$props3.styles,
      rest = _objectWithoutProperties(_this$props3, _excluded);
    return _jsx(View, {
      ...passthroughProps(rest),
      css: styles === null || styles === void 0 ? void 0 : styles.list,
      as: as,
      margin: margin,
      elementRef: this.handleRef,
      display: "block",
      children: this.renderChildren()
    });
  }
}, _List.displayName = "List", _List.componentId = 'List', _List.propTypes = propTypes, _List.allowedProps = allowedProps, _List.defaultProps = {
  as: 'ul',
  delimiter: 'none',
  isUnstyled: false,
  size: 'medium',
  itemSpacing: 'none'
}, _List.Item = ListItem, _List)) || _class) || _class);
export default List;
export { List, ListItem };